import { Typography } from 'antd';
import { PropsWithChildren } from 'react';

import styles from './index.module.scss';

type MobileCardHeaderProps = unknown;

export const MobileCardHeader = ({
  children,
}: PropsWithChildren<MobileCardHeaderProps>) => {
  return (
    <Typography className={styles.mobileCardHeader}>{children}</Typography>
  );
};

export const MobileTableHeader = ({
  children,
}: PropsWithChildren<MobileCardHeaderProps>) => {
  return <h3 className={styles.mobileTableHeader}>{children}</h3>;
};
